<template>
    <div :class="['btn-group drop_mn', { 'last-item': lastIndex, 'show': expanded }]">
        <Button type="button" class="dropdown-toggle" data-cy="opciones" @click="toggle()">
            OPCIONES
        </Button>
        <div :class="['dropdown-menu', { 'show': expanded }]">
            <template v-for="(option, index) in options">
                <div :key="index">
                    <template v-if="option.type === 'action'">
                        <button class="dropdown-item" @click="closeAndTrigger(option.action)">
                            {{ option.label }}
                        </button>
                    </template>
                    <template v-else-if="option.type === 'url'">
                        <a class="dropdown-item" :href="option.url" target="_blank">
                            {{ option.label }}
                        </a>
                    </template>
                    <template v-else>
                        <router-link v-if="option.to" :to="option.to" class="dropdown-item">
                            {{ option.label }}
                        </router-link>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        lastIndex: Boolean,
        options: Array
    },
    data() {
        return {
            expanded: false
        }
    },
    methods: {
        toggle() {
            this.$emit(this.expanded ? 'close' : 'open', this);
            this.expanded = !this.expanded;
        },
        close() {
            this.expanded = false;
        },
        closeAndTrigger(func) {
            this.expanded = false;
            func();
        }
    },
    directives: {
        clickoutside: {
            bind(element, binding, vnode) {
                element.clickOutsideEvent = function(event) {
                    if (!(element === event.target || element.contains(event.target))) {
                        if (event.type === "touchstart" || event.type === "click") {
                            vnode.context[binding.expression](event);
                        }
                    }
                };
                document.body.addEventListener('click', element.clickOutsideEvent);
                document.body.addEventListener('touchstart', element.clickOutsideEvent);
            },
            unbind(element) {
                document.body.removeEventListener('click', element.clickOutsideEvent);
                document.body.removeEventListener('touchstart', element.clickOutsideEvent);
            }
        }
    }
}
</script>

<style scoped>
    .dropdown-item {
        text-transform: uppercase;
    }

    .drop_mn {
        position: relative;
    }

    .drop_mn .dropdown-menu {
        top: 0;
        right: 100%;
        left: auto;
        margin-top: 0;
        margin-right: 0.125rem;
    }

    .drop_mn.last-item .dropdown-menu {
        top: auto !important; 
        bottom: 0 !important;
        right: 100% !important;
        left: auto !important;
    }

    @media (max-width: 768px) {
        .drop_mn .dropdown-menu {
            top: 0;
            right: 100%;
            left: auto;
            margin-top: 0;
            margin-right: 0.125rem;
        }
    }
</style>